import React from 'react';
import PropTypes from 'prop-types';
import { Grid, TableCell, Typography } from '@material-ui/core';

import ReadingsHelpers from 'utils/ReadingsHelpers';
import { useTranslation } from 'react-i18next';

const SurfaceTableCell = ({ surfaceDataType, value, convertTemp, convertPPM, convertUnits }) => {
  let convert = false;
  const { t } = useTranslation();

  convert = ReadingsHelpers.getNeedsConversion(surfaceDataType, convertPPM, convertTemp, convertUnits);
  const display = ReadingsHelpers.displayReading(surfaceDataType, value, '', false, convert);

  const units = ReadingsHelpers.getUnitsForReading(surfaceDataType, convert);

  return (
    <TableCell key={Math.random() * 10000}>
      <Grid container direction="column" alignItems="center" justifyContent="center" key={Math.random() * 10000}>
        {value ? (
          <div key={Math.random() * 10000}>
            <Grid container item direction="column" alignItems="center" key={Math.random() * 10000}>
              <Grid item>
                <Typography variant="subtitle1" key={Math.random() * 10000} align={'justify'}>
                  {t(surfaceDataType)}
                </Typography>
              </Grid>
              <Grid item container direction="row">
                <Typography variant="h1" key={Math.random() * 10000} align={'justify'}>
                  {display}
                </Typography>
                <Typography
                  variant="subtitle2"
                  key={Math.random() * 10000}
                  align={'justify'}
                  style={{ paddingLeft: 5 }}
                >
                  {units}
                </Typography>
              </Grid>
            </Grid>
          </div>
        ) : (
          <></>
        )}
      </Grid>
    </TableCell>
  );
};

SurfaceTableCell.propTypes = {
  surfaceDataType: PropTypes.string,
  value: PropTypes.array,
  convertTemp: PropTypes.bool,
  convertPPM: PropTypes.bool,
  convertUnits: PropTypes.bool,
};

SurfaceTableCell.defaultProps = {
  surfaceDataType: '',
  value: [],
  convertTemp: false,
  convertPPM: false,
  convertUnits: false,
};

export default SurfaceTableCell;
